/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

// @types
import { ServiceRequest, ServiceWithName } from "../../../types/request.types";

// @helpers
import { formatDate } from '../../../helpers/date';

// @store
import useProfileStore from "../../../store/useProfileStore";

interface ServiceCardProps {
  service: ServiceRequest;
  onClick: () => void;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service, onClick }) => {
  const { t } = useTranslation();
  const { professional, getProfessionalInfo } = useProfileStore();

  useEffect(() => {
    if (service.professionalId) {
      getProfessionalInfo(service.professionalId);
    }
  }, [service]);

  return (
    <div
      className="flex flex-col w-full gap-2 bg-white p-4 rounded-2xl cursor-pointer hover:shadow-lg transition"
      onClick={onClick}
      key={service.professionalId}
    >
      <img
        src={service.category.urlImage}
        alt={service.category.name}
        className="rounded-t-lg h-32 w-full object-cover"
      />

      <div className="flex flex-col gap-[5px] mt-4">
        <h4 className="w-full text-cText dark:text-dark-cText font-medium text-lg">{service?.category?.name}</h4>
        <p className="w-full flex justify-end text-cTextSecondary dark:text-dark-cTextSecondary text-sm ">{formatDate(service?.createdAt)}</p>

        <section className="flex flex-row justify-between items-center">
          <div className="flex flex-col gap-[5px]">
            {service?.services.map((service: ServiceWithName) => (
              <p className="text-cTextSecondary dark:text-dark-cTextSecondary text-sm">{service?.name}</p>
            ))}
          </div>
        </section>

        <p className="text-cTextSecondary dark:text-dark-cTextSecondary text-sm font-semibold">{professional?.name}</p>
      </div>
      {service?.serviceRequestStatus === 6 &&
        <section
          className="text-[#F97068] px-2 py-2 rounded-md flex items-center text-[13px] font-semibold border border-[#F97068]"
        >
          {t("professional.services.serviceProcessCompletion")}
        </section>
      }
    </div>
  );
};

export default ServiceCard;
